import { render } from "./ModalSolutions.vue?vue&type=template&id=603bb930"
import script from "./ModalSolutions.vue?vue&type=script&lang=js"
export * from "./ModalSolutions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__